export const MAX_DESCRIPTION_LENGTH = 200;
export const MAX_TAG_LENGTH = 100;
export const MAX_TAGS = 10;
